import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Chan from './views/Chanpin.vue'
import Xiang from './views/Xiang.vue'
import hang from './views/hang.vue'
import Guan from './components/Guan.vue'
import Lianxi from './components/Lianxi.vue'
import Chanx from './components/Chanxiang.vue'
import Gongc from './components/Gongc.vue'
import Gongx from './components/Gongx.vue'
import engineering from './components/engineering.vue'
import Testing from './components/Testing.vue'

Vue.use(Router)

export default new Router({
  routes: [
    /*首页*/ 
    {
      path: '/',
      name: 'home',
      component: Home
    },
    /*产品中心*/
    /*{
      path: '/chan/:id',
      name:'chan',
      component: Chan
    },*/
    /*产品组*/
    {
      path: '/xiang',
      component:Xiang,
      children:[
        /*公司介绍*/
        {
          path:'/chan',
          name:'chan',
          component: Chan
        },
        {
          path: '/xiang/guan',
          component: Guan
        },
        /*联系我们*/
        {
          path: '/xiang/lian',
          component: Lianxi
        },
        /*产品的详情页面*/
        {
          path: '/xiang/chanx',
          component: Chanx
        },  
      ]
    },
    {
    /*咨询中心*/
      path: '/hang',
      component:hang,
      children:[
        /*工程案例 */
        {
          path: '/hang/engineering/',
          component: engineering
        },
        {
          path: '/hang/Testing/',
          component: Testing
        },
        {
          path: '/hang/gong/',
          component: Gongc
        },
        {
          path: '/hang/gong/:id',
          component: Gongc
        },
        /*工程案例的详情*/
        {
          path: '/hang/gonx/:id',
          component: Gongx
        },
      ]
    }
  ]
})
